import * as React from 'react';
import { useState } from 'react';
import { DesignSystemHtmlElement } from '../../../lib/constants/constants';

declare global {
  namespace React.JSX {
    interface IntrinsicElements {
      'sagov-text-input': DesignSystemHtmlElement;
      'sagov-search-icon': DesignSystemHtmlElement;
    }
  }
}

interface TableSearchProps {
  globalFilter: string;
  setGlobalFilter: (filter: string | undefined) => void;
  placeholderText: string;
}

export const TableSearch = ({
  globalFilter,
  setGlobalFilter,
  placeholderText,
}: TableSearchProps): React.JSX.Element => {
  const [value, setValue] = useState(globalFilter);
  React.useEffect(() => {
    setValue(globalFilter);
  }, [globalFilter]);
  const onChange = (value: string): void => {
    setGlobalFilter(value || undefined);
  };

  const updateSearch = (value: string): void => {
    setValue(value);
    window.setTimeout(async () => onChange(value), 200);
  };

  return (
    <section aria-label="Search">
      <div role="search">
        <sagov-text-input
          value={value || ''}
          onKeyUp={(e: { target: { value: never } }) => updateSearch(e.target.value)}
          onClick={(e: { target: { value: never } }) => updateSearch(e.target.value)}
          placeholder={placeholderText}
          aria-label={placeholderText}
          clearlabel="Clear search text"
        >
          <sagov-search-icon aria-hidden="true" slot="prefix-icon" />
        </sagov-text-input>
      </div>
    </section>
  );
};
